import styled from 'styled-components';

const Divider = styled("div")`
  border-top: 1px solid #f1f3f5;
  margin: 24px 0px;
`;

export default Divider;
